import React, { useState } from 'react';
import TodoForm from '../todo/TodoForm';
import TodoTaskLists from './TodoTaskLists';
import todoDashboardImg from "../images/todo-dashboard-img.png"
import '../styles.css';


const TodoHome = () => {

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isTodos, setIsTodos] = useState(true);
  const [isTasksAvailable, setIsTasksAvailable] = useState(false);



  return (
    <>
      <div className='w-full  lg:w-full xl:w-full'>
        <div className="flex flex-col">
          <div className='flex flex-col   xs:flex-col   sm:flex-col   md:flex-row'>
            <div className='mx-auto order-2   xs:order-2   sm:order-2    md:order-1 md:w-[440px]   smLaptop:w-[600px] smLaptop:order-1   lg:w-[750px] lg:order-1     xl:w-[825px] xl:order-1  '>
              <TodoForm setIsSubmitted={setIsSubmitted} setIsTodos={setIsTodos} setIsTasksAvailable={setIsTasksAvailable} />
            </div>
            <div className='order-1   xs:order-1    sm:order-1    md:order-2 md:float-right md:w-[430px] md:h-[250px]    smLaptop:w-[350px] smLaptop:order-2    lg:w-[430px] lg:order-2   xl:w-[430px] xl:order-2  '>
              <img src={todoDashboardImg} alt="todo" className='md:h-[240px] smLaptop:h-[300px] lg:h-[300px]  xl:ml-8    ' />
            </div>
          </div>
          <div>
            <TodoTaskLists isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} isTodos={isTodos} setIsTodos={setIsTodos} isTasksAvailable={isTasksAvailable} setIsTasksAvailable={setIsTasksAvailable} />
          </div>
        </div>
      </div>
    </>
  )
}


export default TodoHome;